import { useQuery } from "@tanstack/react-query";
import { useUserContext } from "./useUserContext";
import { getPermissions } from "../_firebase/permissions";
import { StoredPermissions } from "../@types/permissions";

export const useGetPermissions = () => {
  const { uid: userId } = useUserContext();
  const { data, error, isLoading, isError, refetch } = useQuery<
    StoredPermissions | null,
    Error
  >({
    queryKey: [userId, "permissions"],
    queryFn: () => getPermissions(userId),
    enabled: !!userId,
    staleTime: 1800000, // 30 minutes
    gcTime: 150000, // 2.5 minutes
  });

  return { data, error, isLoading, isError, refetch };
};
